import { authUrls } from "@cervval.js/common-auth/src/authRoutes";
import { LoginData, User } from "@cervval.js/common-auth/src/loginData.model";
import { Injectable } from "@cervval.js/common/src/dependencies/injectable";
import { CLIENT_AUTHENTICATION_SERVICE, ClientAuthenticationService } from "./clientAuthentication.service";

@Injectable(CLIENT_AUTHENTICATION_SERVICE)
export class DefaultClientAuthenticationService<AppUser extends User = User, CustomLoginData extends LoginData<AppUser> = LoginData<AppUser>> implements ClientAuthenticationService<AppUser, CustomLoginData> {
    constructor(protected _loginData: CustomLoginData) { }

    /**
     * Redirects the user to the login page or SSO application
     */
    public redirectToLogin(): Promise<void> {
        window.location.href = authUrls.loginClientAppUrl;
        return Promise.resolve();
    }


    /**
     * @returns the client loginData
     */
    public getLoginData(): CustomLoginData {
        return this._loginData;
    }

    /**
     * Set the data for the current logged-in user.
     * @param loginData current user login data
     */
    public setLoginData(loginData: CustomLoginData): void {
        this._loginData = loginData;
    }
}